<div class="main-page">
  <app-header></app-header>
  <div class="container">
    <ngx-spinner></ngx-spinner>
    <div class="plans-area">
      <div class="innerPage plans-area-inner">
        <div class="row">
          <div class="col-md-12 col-md-offset-3">
            <form id="msform" [formGroup]="bannerForm" (submit)="onSubmit()">
              <fieldset>
                <h2 class="fs-title">ADD BANNER DETAILS</h2>
               <span *ngIf= "imageUrl"  > <img width="100%"  [src]="imageUrl" class="image" (click)="redirectImage(imageUrl)"></span>
                <div class="form-group"
                  [ngClass]="{ 'has-error': bannerForm.get('image').invalid && bannerForm.get('image').touched }">
                  <label for="exampleFormControlFile1">Select Banner Image</label>
                  <input type="file" class="form-control-file" id="exampleFormControlFile1" formControlName="image"
                    (change)="readUrl($event)">
                  <div *ngIf="bannerForm.get('image').invalid && bannerForm.get('image').touched" class="error">
                    <span *ngIf="bannerForm.get('image').hasError('required')">Please select an image.</span>
                  </div>
                </div>
                <p  class="banner"> Banner dimensions should be: {{maxWidth}} pixels width by {{minHeight}} pixels height.</p>
                <p  class="fileSize">(Maximum banner size allowed is 25 MB) File type should be JPG or PNG</p>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">Select Banner Category</label>
                  <select formControlName="bannerCategory" class="form-control" id="exampleFormControlSelect1">
                    <option value="" disabled selected>Select Category</option>
                    <option *ngFor="let business of businessCategory; let i = index;" [value]="business._id">
                      {{business.category}}</option>
                  </select>
                  <div *ngIf="bannerForm.get('bannerCategory').invalid && bannerForm.get('bannerCategory').touched"
                    class="error">Please select a banner category.</div>
                </div>

                <div class="form-group">
                  <label class="mt-2">{{label}}
                  </label>
                  <input [readonly]="label == 'Global Visibility'" formControlName="location" type="text" name="location_name" class="form-control"
                    placeholder="Location Name" #addresstextNew (input)="addressChange()" />
                  <div *ngIf="!isLocation" class="error">
                    Please enter a location name.</div>
                </div>

                <div class="form-group">
                  <label class="mt-2">Add Url
                  </label>
                  <input formControlName="url" type="text" name="url" class="form-control"
                    placeholder="Enter Url" />
                  <div *ngIf="bannerForm.get('url').invalid && bannerForm.get('url').touched" class="error">
                    Please enter a url.</div>
                </div>
                <div *ngIf="planName === 'Regional'">
                  <div class="form-group">
                    <label>Choose Visibility Radius</label>
                    <div class="select-your-choice d-flex justify-content-between">
                      <div class="form-check" *ngFor="let sub of milesArray ">
                        <input formControlName="radius" type="radio" [value]="sub?.miles" class="form-check-input"
                          name="q" [id]="sub?.id">
                        <label class="form-check-label" [for]="sub?.id">{{sub?.miles}} {{sub?.type }}</label>
                      </div>
                    </div>
                    <div *ngIf="bannerForm.get('radius').invalid && bannerForm.get('radius').touched" class="error">
                      Please Choose a Radius</div>
                  </div>
                </div>

                <div class="d-flex justify-content-center">
                  <button type="submit" name="submit" class="submit action-button btn-success">{{buttonText}}</button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
